module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "location-email.0d5d8220.svg";